
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import Navbar from '../../components/navbar';
import vector6 from '../../assets/img/Vector6.png';
import arrow from '../../assets/img/arrow.svg';
import midias from '../../assets/img/Social Media.svg';
import africangirl from '../../assets/teamsobr/africangirl.png'
import vector13 from '../../assets/teamsobr/vector13.svg'
import vector14 from '../../assets/teamsobr/vector14.svg'
import vector15 from '../../assets/teamsobr/vector15.svg'
import vector16 from '../../assets/teamsobr/vector16.svg'
import couple3 from '../../assets/img/africancouple.png'
import google from '../../assets/img/boton google play.svg';
import apple from '../../assets/img/boton app store.svg';
import ny from '../../assets/img/nyc.svg';
import estilo from '../../assets/img/background-vector.png';
import background from '../../assets/img/backgroundvector.svg'; // Caminho para a imagem
import felipefoto from '../../assets/img/felipefoto.jpg'
import digaofoto from '../../assets/img/digaofoto.jpg'
import ricardofoto from '../../assets/img/ricardofoto.jpg'
import maltefoto from '../../assets/img/maltefoto.jpg'
import kochfoto from '../../assets/img/kochfoto.jpg'
import ericofoto from '../../assets/img/erikofoto.jpg'


const Home = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
    <>

    <header className="header-containerx">
    <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/es">Home</a>
                <a href="/embajadores">Embajadores</a>
                <a href="/equiposobr">Equipo Sobr</a>
                <a href="/terminosypolitica">Términos y Políticas</a>

            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/br">pt-BR</a>
            </div>
        </header>

        <body>

                <div className="iphone3">
                    <main>
                    <section className="hero5">
                    <h1>Bienvenido a Sobr, donde el viaje hacia la felicidad es vibrante y alentador.</h1>
                    <p> Somos mucho más que una aplicación de citas: somos una comunidad dedicada a redefinir el concepto de felicidad poniendo la sobriedad en el centro de todo lo que hacemos.
                    </p>             
                    <button className="demo-button">DERSCARGAR AHORA</button>
                    </section>
                    </main>
                </div>


                <div className="content12dsk">
                    <img className='like2' src={africangirl} alt="like" title="like" height="500" />  
                    <section>       
                    <p>En Sobr, creemos que la verdadera felicidad no sólo es posible, sino alcanzable para todos. Nuestra misión es proporcionar un espacio acogedor y fortalecedor para aquellos que eligen vivir una vida sobria, celebrando cada momento de alegría, cada logro y cada paso hacia el crecimiento personal.                   </p>
        <p>Nuestro compromiso con la autenticidad, la salud y las relaciones sobrias genuinas es lo que nos impulsa cada día. Aquí encontrarás una vibrante comunidad de personas con ideas afines dispuestas a apoyarse, inspirarse y empoderarse mutuamente en su viaje hacia la sobriedad.        </p>
        <p>Así que si estás listo para embarcarte en un viaje de autoconocimiento, conexión significativa y auténtica alegría, has venido al lugar correcto. Únete a nosotros en Sobr y revolucionemos juntos la felicidad.        </p>                                   
                    </section>  
                </div>
                <div className='downloaddsk'>
                    <h3> Download the app today! </h3>
                <img className="google3" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className="content7dsk">
                    <h1>Bienvenido a nuestra comunidad. Bienvenido a Sobr.</h1>
                </div>
                {/* <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div> */}

<div className="team-container">
<div className="team-card">
        <div className="profile-image-container">
        <img src={digaofoto} alt="Rodrigo" className="profile-image" />
    </div>
        <div className="team-info">
            <h2 className="team-name">Rodrigo Oliveira</h2>
            <h3 className="team-title">Co-Fundador y Director Comercial</h3>
            <p className="team-description">
            Ha trabajado en empresas como Panasonic de Brasil, Stanley’s Care, entre otras...
            </p>
        </div>
    </div>
    <div className="team-card">
    <div className="profile-image-container">
        <img src={felipefoto} alt="Felipe" className="profile-image" />
    </div>
    <div className="team-info">
        <h2 className="team-name">Felipe Alarcon</h2>
        <h3 className="team-title">Co-Fundador y CEO</h3>
        <p className="team-description">
        Fue gerente de operaciones de BITNATION, ganadora del Gran Premio de la UNESCO, y gerente de productos de CryptoMarket.
        </p>
        </div>
    </div>
    <div className="team-card">
    <div className="profile-image-container">
        <img src={kochfoto} alt="Koch" className="profile-image" />
    </div>
    <div className="team-info">
        <h2 className="team-name">Marcus Koch</h2>
        <h3 className="team-title">Co-Fundador y CTO</h3>
        <p className="team-description">
        Colaboró en la creación de la aplicación del grupo DocPlanner.
        </p>
    </div>
    </div>
    <div className="team-card">
        <div className="profile-image-container">
        <img src={ericofoto} alt="Érico Ramos" className="profile-image" />
    </div>
        <div className="team-info">
            <h2 className="team-name">Érico Ramos</h2>
            <h3 className="team-title">Accionista Minoritario</h3>
            <p className="team-description">
            Trabajó como consultor en Accenture, Google y Nokia.
            </p>
        </div>
    </div>
    <div className="team-card">
    <div className="profile-image-container">
        <img src={maltefoto} alt="Malte Niebelschuetz" className="profile-image" />
    </div>
    <div className="team-info">
        <h2 className="team-name">Malte Niebelschuetz</h2>
        <h3 className="team-title">Director Comercial - EE.UU.</h3>
        <p className="team-description">
        Trabajó como gerente de proyectos en Deutsche Telekom y ahora tiene negocios en San Diego.
        </p>
        </div>
    </div>
    <div className="team-card">
    <div className="profile-image-container">
        <img src={ricardofoto} alt="Ricardo Aquino" className="profile-image" />
    </div>
    <div className="team-info">
        <h2 className="team-name">Ricardo Aquino</h2>
        <h3 className="team-title">CMO</h3>
        <p className="team-description">
        Contribuyó para marcas como Petrobras, Ponto Frio, Grupo Pão de Açúcar, entre otras.
        </p>
    </div>
    </div>
    </div>
                <footer>
                    <div className="footer-contentdsk">
                        <p>Termos de Servicio | Política de Privacidad</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc., Todos los Derechos Reservados
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Home;
